export class AddOns {
    public static OnUploadFileSizeNotification: number = 1;
    public static CVDistribution: number = 2;
    public static CVAndProfileReviewCall: number = 3;
    public static MatchingJobs: number = 4;
    public static AutoSearches: number = 5;
    public static CareerAdviceCall: number = 6;
    public static VerificationAndScreening: number = 7;
    public static JobSearchRequest: number = 8;
    public static VideoIntroduction: number = 9;
    public static MockInterviewVideoCall: number = 10;
    public static UnlimitedConnectAndMessage: number = 11;
    public static IndustryForums: number = 12;
    public static FeaturedProfile: number = 13;
    public static SoftSkillsFeedbackReport: number = 14;
    public static CVBlast: number = 15;
    public static JobAlertsAddOnsId: number = 73;
    //Recruiter
    public static UnlimitedStandardJobs: number = 16;
    public static FeaturedJobs: number = 17;
    public static MultipostJobs: number = 103;
    public static UnlimitedConnectAndMessageRecruiter: number = 19;
    public static UnlockConnectedCVs: number = 20;
    public static IndustryForumsRecruiter: number = 21;
    public static CompanyProfile: number = 22;
    public static ViewVerifiedVideoProfiles: number = 23;
    public static UnlimitedInternalCVDatabase: number = 24;
    public static MatchingCVs: number = 25;
    public static AutoSearchesRecruiter: number = 26;
    public static CVDownloads: number = 27;
    public static ScreenedCandidates: number = 28;
    public static SoftSkillsReportDownload: number = 29;
    public static HumaTecVacancy: number = 30;
    public static Search4mePro: number = 102;
    public static HumaTecDailySearch: number = 31;
    public static FeaturedEmployer: number = 32;
    public static ExpertCVResourcing: number = 33;
    public static JobBlast: number = 34;
    public static EmailEngagements: number = 35;
}